<mat-icon matRipple [matRippleCentered]="true" [matRippleUnbounded]="true" [matRippleRadius]="20" class="icon" (click)="openInfoDialog()">info</mat-icon>
<div [hidden]="true">
  <div #dialogContent>
    <ng-content ></ng-content>
  </div>
</div>
